import { render } from "./dropzone.vue?vue&type=template&id=1aa0bace"
import script from "./dropzone.vue?vue&type=script&lang=js"
export * from "./dropzone.vue?vue&type=script&lang=js"

import exportComponent from "/home/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/dropzone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1aa0bace"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1aa0bace', __exports__)) {
    api.reload('1aa0bace', __exports__)
  }
  
  module.hot.accept("./dropzone.vue?vue&type=template&id=1aa0bace", () => {
    api.rerender('1aa0bace', render)
  })

}


export default __exports__